import { styles as tabStyles } from "Common/Components/MNTabs/styles";

export const styles = {
  drawer: {
    "& .MuiDrawer-paper": {
      width: { xs: "100%", sm: "400px" },
      p: "1.5rem",
      boxSizing: "border-box",
      overflowY: "auto",
      overscrollBehavior: "contain",
    },
  },
  tabStyle: (isSelected) => ({
    ...tabStyles.MNTabStyle(isSelected),
    fontSize: "0.9rem",
  }),
  title: {
    color: "text.secondary",
    fontSize: "1.25rem",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
};
